import * as actions_timeclock from 'actions/timeclock-actions';
import * as actions_users from 'actions/users-actions';
import React, { useEffect, useState } from 'react';
import UserActivation from 'components/common/user-activation';
import _ from 'lodash';
import firebase from 'firebase/compat/app';
import moment from 'moment';
import { CONTACTS, ROLES } from 'components/constants';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { DashboardDetail } from 'enspire-manager-framework';
import { confirm } from 'components/common/toolbox';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

export const Contact = (props) => {

	const params = useParams();
	const history = useHistory();
	const dispatch = useDispatch();

	const user_permissions = useSelector(store => store.users?.user_permissions);
	const users = useSelector((store) => store.users);
	const workOrders = useSelector((store) => store.workOrders);

	const [showContact, setShowContact] = useState(false);
	const [showActivation, setShowActivation] = useState(false);
	const [user, setUser] = useState(null);

	useEffect(() => {
		if (user) {
			setShowContact((user?.activated == true) ? false : true);
			setShowActivation((user?.activated == true) ? false : true);
		}
	}, [user?.activated]);

	useEffect(() => {
		if (props.contact?.email) {
			const fetchUser = async () => {
				const userDoc = await firebase.firestore().collection(params.handle + '/users/users').doc(props.contact.email).get();
				setUser(userDoc.data());
			}	
			fetchUser();
		}
	}, [props.contact]);

	/* Handlers --------------------------*/

	const viewAs = () => {
		if (typeof users?.user_unsubscribe === "function") users?.user_unsubscribe();
        if (typeof users?.time_clock_unsubscribe === "function") users?.time_clock_unsubscribe();
		if (typeof users?.user_permissions_unsubscribe === "function") users?.user_permissions_unsubscribe();
        if (typeof workOrders?.work_orders_open_unsubscribe === "function") workOrders?.work_orders_open_unsubscribe();

		dispatch(actions_users.subUser(params.handle, props.contact?.email, (userdata) => {
			dispatch(actions_users.viewAs((firebase.auth().currentUser.email != props.contact?.email) ? props.contact?.email : null));
			dispatch(actions_timeclock.subTimeClock(params.handle, props.contact?.email));
			dispatch(actions_users.subUserPermissions(params.handle, props.contact?.email));
			dispatch(actions_users.subUserRecentItems(params.handle, props.contact?.email));

			// if (userdata.roles.includes(ROLES.ASSET_CUSTOMER.id)) {
			// 	history.push(`/${params.handle}/${params.appId}/assets`);
			// } else {
			// 	history.push(`/${params.handle}/${params.appId}/dashboard/0/overview/work-orders`);
			// }	

			history.push(`/${params.handle}/${params.appId}/assets`);
		}));
	}
	
	/* Constants --------------------------*/
	
	const hasPortal = user?.roles?.length;
	const contactType = _.find(Object.values(CONTACTS), { id: props.contact.contactTypeId });
	const typeName = (contactType?.name) ? <strong>{contactType.name + ': '}</strong> : '';
	const displayName = (props.contact?.firstName || props.contact?.lastName)
		? props.contact.firstName + ' ' + props.contact.lastName
		: '- No Contact Name -';
	const roleBadges = user?.roles?.map((role) => {
		let name = Object.values(ROLES).find((o) => o.id == role)?.name;
		return name ? <span className="badge badge-secondary mr-2">{name}</span> : null;
	});

	return (

		<div>
			{props.contact &&
				<div>
					<div onClick={() => { setShowContact(!showContact); }} style={{ cursor: 'pointer', marginBottom: '7px', paddingBottom: '1px' }}>
						{showContact
							? <span className="float-right px-1 ml-2" style={{ fontSize: '16px' }}><i className="fas fa-angle-up"></i></span>
							: <span className="float-right px-1 ml-2" style={{ fontSize: '16px' }}><i className="fas fa-angle-down"></i></span>
						}
						{(props.contact.firstName || props.contact.lastName) &&
							<DashboardDetail icon={ 'fas fa-user' } value={ <>{typeName} <span>{roleBadges}</span> {displayName}</> } callback={ () => { props.editCallback(props.contact.id); } } />
						}
					</div>
					{showContact &&
						<div className="ml-2">
							<div style={{ width: '100%' }}>
								{props.contact.contactPhone &&
									<DashboardDetail icon={ 'fas fa-phone' } type="phone" value={ props.contact.contactPhone } />
								}
								{props.contact.mobile &&
									<DashboardDetail icon={ 'fas fa-mobile' } type="phone" value={ props.contact.mobile } />
								}
								{props.contact.email &&
									<DashboardDetail icon={ 'fas fa-envelope' } type="email" value={ props.contact.email } />
								}
							</div>

							{/* <div className="ml-2 mt-2">
								{(props.contact.notifyViaEmail || props.contact.notifyViaSms) &&
									<span className="mt-1"> Notify Via: </span>
								}
								{props.contact.notifyViaEmail &&
									<span className="ml-2 mt-1"><i className="fas fa-envelope"></i></span>
								}
								{props.contact.notifyViaSms &&
									<span className="ml-2 mt-1"><i className="fas fa-sms"></i></span>
								}
							</div> */}

							{ props.contact.email && !!hasPortal &&
								<UserActivation user={ user } bgColor={ 'grey' } />
							}
							{ typeof props.editCallback === "function" &&
								<button className="btn btn-default btn-sm float-right mt-3" onClick={ () => { props.editCallback(props.contact.id); } }>
									Edit Contact
								</button>
							}
							{ typeof props.portalCallback === "function" &&
								<>
									{ props.contact.email 
										? 	<>
												{ hasPortal
													?	<>
															<button className="btn btn-primary btn-outline btn-sm mt-3" onClick={ () => {
																confirm(`Are you sure to want to DISABLE the Customer Portal for this user?`, () => props.portalCallback(props.contact, false)); 
															}}>
																<i className="fa-solid fa-check mr-1"></i> Customer Portal Enabled
															</button>
															{(user_permissions?.SUPERADMIN) &&
																<button type="button" 
																	className={'btn btn-info btn-sm ml-2 mt-3'}
																	onClick={viewAs}><i className="fa-regular fa-shield mr-1"></i>View As
																</button>
															}
														</>
													:	<button className="btn btn-default btn-sm mt-3" onClick={ () => {
															confirm(`Are you sure to want to ENABLE the Customer Portal for this user?`, () => props.portalCallback(props.contact, true)); 
														}}>
															<i className="fa-solid fa-user mr-1"></i> Enable Customer Portal
														</button>
												}
											</>
										:	<button className="btn btn-default btn-sm mt-3" onClick={ () => {
												window.toastr.error('In order to create a Customer Portal, the contact must have an email address.', 'Email Required!'); 
											}}>
												<i className="fa-solid fa-user-times mr-1"></i> Email Required for Customer Portal
											</button>
									}
								</>
							}
							<div style={{ clear: 'both' }} className="mb-3" />
						</div>
					}
				</div>
			}
		</div>
	);
}
